module.exports = __webpack_public_path__ + "static/img/success.5a038ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success.png
// module id = mzrL
// module chunks = 4